import {
  OFFER_CARGO_VEHICLE_SHAPES_LIST,
  VEHICLE_SIZES,
} from "@/shared/constants/offer-cargo";
import { formatMoney } from "@/shared/lib/currency";
import { toLocaleTextAsDate } from "@/shared/lib/datetime";
import { Stack, styled } from "@mui/material";
import type { FreightMatching } from "@x-mile/api-contract";

const ItemTitle = styled("div")(({ theme }) => ({
  width: 36,
  height: 24,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.grey[700],
  fontSize: "12px",
}));

const ItemValue = styled("div")(({ theme }) => ({
  fontSize: "12px",
  color: theme.palette.grey[900],
}));

type Props = {
  payload: FreightMatching.schemas.Notification["payload"];
  deliveryProposalOfferCargo?: FreightMatching.schemas.OfferCargo;
};

export const NotificationDetail = ({
  payload: { type },
  deliveryProposalOfferCargo,
}: Props) => {
  if (type === "delivery_proposal_created" && deliveryProposalOfferCargo) {
    return <OfferCargoDetail offerCargo={deliveryProposalOfferCargo} />;
  }

  return null;
};

const OfferCargoDetail = ({
  offerCargo,
}: { offerCargo: FreightMatching.schemas.OfferCargo }) => {
  const loading = offerCargo.destinations[0];
  const unloading = offerCargo.destinations[1];

  const vehicleShapeText =
    OFFER_CARGO_VEHICLE_SHAPES_LIST.find(
      (shape) => shape.value === offerCargo.vehicleShape,
    )?.label ?? "-";

  const vehicleSizeText =
    VEHICLE_SIZES.find((size) => size.value === offerCargo.vehicle?.size)
      ?.label || "";

  return (
    <Stack direction={{ xs: "column", sm: "row" }} spacing={{ xs: 0.5, sm: 2 }}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <ItemTitle>積卸</ItemTitle>
        <ItemValue>
          {toLocaleTextAsDate(new Date(offerCargo.loadingOn), true)}{" "}
          {loading.prefecture + loading.address}
          {" → "}
          {toLocaleTextAsDate(new Date(offerCargo.unloadingOn), true)}{" "}
          {unloading.prefecture + unloading.address}
        </ItemValue>
      </Stack>

      <Stack direction="row" alignItems="center" spacing={1}>
        <ItemTitle>車両</ItemTitle>
        <ItemValue>
          {vehicleShapeText}/{vehicleSizeText ? `${vehicleSizeText}/` : ""}
          {offerCargo.vehicleWeight}t
        </ItemValue>
      </Stack>

      <Stack direction="row" alignItems="center" spacing={1}>
        <ItemTitle>運賃</ItemTitle>
        <ItemValue>{formatMoney(offerCargo.shippingFee)}</ItemValue>
      </Stack>
    </Stack>
  );
};
